import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./TopBar.css";

const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || "/backend";

function TopBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(window.scrollY);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1200);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    let scrollTimeout;
    
    const handleScroll = () => {
      // Hide the navbar while scrolling
      setVisible(false);
      
      // Clear the previous timeout
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      
      // Set a new timeout to show the navbar after scrolling stops
      scrollTimeout = setTimeout(() => {
        setVisible(true);
      }, 200); // Adjust this value to control how long to wait after scrolling stops
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
    };
  }, []);

  useEffect(() => {
    if (!isMobile) {
      setMenuOpen(false);
    }
  }, [isMobile]);

  return (
    <div className={`top-bar ${visible ? 'visible' : 'hidden'}`}>
      {/* Left section: Logo and Title */}
      <div className="top-bar-left">
        <img 
          src="horizontal_logo.png" 
          alt="Connection Health Care Logo"
          className="top-bar-logo"
        />
        {/* <span style={{ fontWeight: 700, fontSize: '1.5rem', color: '#004080' }}>Connection Health Care</span> */}
        <Link
          to="/zh"
          className="language-button"
          onClick={() => window.scrollTo(0, 0)}
        >
          中文
        </Link>
      </div>

      {/* Desktop navigation tabs (hidden on mobile) */}
      {!isMobile && (
        <div className="top-bar-tabs">
          <Link to="/" className="top-bar-tab" onClick={() => window.scrollTo(0, 0)}>Home</Link>
          <Link to="/services" className="top-bar-tab" onClick={() => window.scrollTo(0, 0)}>Services</Link>
          <Link to="/bookingform" className="top-bar-tab" onClick={() => window.scrollTo(0, 0)}>Book Now</Link>
          <Link to="/aboutus" className="top-bar-tab" onClick={() => window.scrollTo(0, 0)}>About Us</Link>
          <Link to="/ourteam" className="top-bar-tab" onClick={() => window.scrollTo(0, 0)}>Our Team</Link>
          <Link to="/career" className="top-bar-tab" onClick={() => window.scrollTo(0, 0)}>Careers</Link>
          <a href="#contact-form" className="top-bar-tab" onClick={(e) => {
            e.preventDefault();
            const element = document.getElementById('contact-form');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }}>Contact</a>
          <Link to={`${FRONTEND_URL}/login`} className="top-bar-tab login-btn" onClick={() => window.scrollTo(0, 0)}>Login</Link>
        </div>
      )}

      {/* Mobile menu button */}
      {isMobile && (
        <button
          className="top-bar-menu-btn"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Open menu"
        >
          ☰
        </button>
      )}

      {/* Dropdown menu on mobile when open */}
      {isMobile && menuOpen && (
        <div className="top-bar-dropdown">
          <Link to="/" className="top-bar-tab" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>Home</Link>
          <Link to="/services" className="top-bar-tab" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>Services</Link>
          <Link to="/bookingform" className="top-bar-tab" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>Book Now</Link>
          <Link to="/aboutus" className="top-bar-tab" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>About Us</Link>
          <Link to="/ourteam" className="top-bar-tab" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>Our Team</Link>
          <Link to="/career" className="top-bar-tab" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>Careers</Link>
          <a href="#contact-form" className="top-bar-tab" onClick={(e) => {
            e.preventDefault();
            setMenuOpen(false);
            const element = document.getElementById('contact-form');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }}>Contact</a>
          <Link to={`${FRONTEND_URL}/login`} className="top-bar-tab login-btn" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>Login</Link>
        </div>
      )}
    </div>
  );
}

export default TopBar;